import { getReq, postReq, putReq, createUrl } from '@/infra/http';
import { PagedResponseModel, BaseResponseModel } from '@/models/core.model';
import {
  CommissionPolicy,
  CommissionPolicyUpsertRequest,
  Purchase,
  PurchasePaginationFilter,
  purchaseFromJson,
} from '@/models/marketplace.model';

export const getPagedPurchases = async (input: PurchasePaginationFilter): Promise<PagedResponseModel<Purchase>> => {
  return await getReq(createUrl('a/Marketplace/Purchase/PagedData'), { params: input }).then((res: any) => ({
    ...res.data,
    result: res.data.result.map((itm: any) => purchaseFromJson(itm)),
  }));
};

export const getCommissionPolicies = async (): Promise<BaseResponseModel<CommissionPolicy[]>> => {
  return await getReq(createUrl('a/Marketplace/CommissionPolicy')).then((res: any) => res.data);
};

export const createCommissionPolicy = async (
  input: CommissionPolicyUpsertRequest
): Promise<BaseResponseModel<CommissionPolicy>> => {
  return await postReq(createUrl('a/Marketplace/CommissionPolicy'), input).then((res: any) => res.data);
};

export const updateCommissionPolicy = async (
  id: number,
  input: CommissionPolicyUpsertRequest
): Promise<BaseResponseModel<CommissionPolicy>> => {
  return await putReq(createUrl(`a/Marketplace/CommissionPolicy/${id}`), input).then((res: any) => res.data);
};
